// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3gFDQ","bigColWidth":"Table_bigColWidth__2apmj","biggerColWidth":"Table_biggerColWidth__rSuBA","row":"Table_row__md-Ue","col":"Table_col___i_mO"};